var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMain7BackgroundComputer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 470,
    height: 333,
    viewBox: "0 0 470 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.565 4.86799C116.945 2.25586 121.055 2.25586 123.435 4.86799L136.6 19.317L155.225 13.386C158.592 12.3138 162.152 14.3691 162.907 17.8213L167.083 36.9167L186.179 41.093C189.631 41.848 191.686 45.4079 190.614 48.775L184.683 67.4003L199.132 80.5648C201.744 82.9447 201.744 87.0553 199.132 89.4352L184.683 102.6L190.614 121.225C191.686 124.592 189.631 128.152 186.179 128.907L167.083 133.083L162.907 152.179C162.152 155.631 158.592 157.686 155.225 156.614L136.6 150.683L123.435 165.132C121.055 167.744 116.945 167.744 114.565 165.132L101.4 150.683L82.775 156.614C79.4079 157.686 75.848 155.631 75.093 152.179L70.9167 133.083L51.8212 128.907C48.3691 128.152 46.3138 124.592 47.386 121.225L53.317 102.6L38.868 89.4352C36.2559 87.0553 36.2559 82.9447 38.868 80.5648L53.317 67.4003L47.386 48.775C46.3138 45.4079 48.3691 41.848 51.8213 41.093L70.9167 36.9167L75.093 17.8212C75.848 14.3691 79.4079 12.3138 82.775 13.386L101.4 19.317L114.565 4.86799Z",
    fill: "#0707AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M450.435 314.497H86.5061L106.308 76.7052C107.314 64.6415 117.414 55.3621 129.533 55.3621H446.689C460.323 55.3621 471.044 66.9991 469.914 80.567L450.431 314.501L450.435 314.497Z",
    fill: "url(#paint0_linear_21_4975)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 80,
    r: 7,
    fill: "#FF5473"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 80,
    r: 7,
    fill: "#FFEA7A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 80,
    r: 7,
    fill: "#1FDE77"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.356 222.271H133.541C124.468 222.271 117.329 214.543 118.05 205.517L125.53 112.279C126.177 104.215 132.919 98 141.02 98H231.835C240.908 98 248.047 105.728 247.326 114.753L239.846 207.991C239.199 216.055 232.457 222.271 224.356 222.271Z",
    fill: "#4A67FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M416.437 276.479H204.713C194.959 276.479 187.278 268.17 188.059 258.463L197.913 135.613C198.61 126.941 205.857 120.259 214.567 120.259H426.291C436.045 120.259 443.726 128.568 442.945 138.274L433.091 261.124C432.394 269.796 425.147 276.479 416.437 276.479Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M229.632 276.783H204.753C194.974 276.783 187.272 268.444 188.055 258.702L197.935 135.41C198.634 126.706 205.901 120 214.634 120H242.196L229.632 276.783Z",
    fill: "#222228"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M294.571 139.717H421.776",
    stroke: "#73737B",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.04 139.717H285.193",
    stroke: "#3354FF",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M290.669 175.99H417.874",
    stroke: "#73737B",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.138 175.99H281.287",
    stroke: "#3354FF",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M288.535 194.122H415.736",
    stroke: "#73737B",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M251 194.122H279.153",
    stroke: "#8BBDFF",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M293.104 157.508H420.305",
    stroke: "#73737B",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M255.569 157.508H283.723",
    stroke: "#8BBDFF",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M347.082 297.317H433.188C442.774 297.317 450.556 305.088 450.556 314.661C450.556 324.233 442.774 332.004 433.188 332.004H347.082V297.322V297.317Z",
    fill: "#0707AB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M342.954 297H18.046C8.07945 297 0 304.835 0 314.5C0 324.165 8.07945 332 18.046 332H342.954C352.921 332 361 324.165 361 314.5C361 304.835 352.921 297 342.954 297Z",
    fill: "#506CFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M139.516 297.317H211.004V298.537C211.004 304.8 205.911 309.885 199.64 309.885H150.881C144.609 309.885 139.516 304.8 139.516 298.537V297.317Z",
    fill: "#0707AB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_4975",
    x1: 273.5,
    y1: 100.5,
    x2: 257.5,
    y2: 365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1142C1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain7BackgroundComputer);
export default __webpack_public_path__ + "static/media/main7-background-computer.0daabd059e3cff5d5930311c221fe7ba.svg";
export { ForwardRef as ReactComponent };